import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Space } from 'antd';
import styled from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { FileType } from '../../../../file-storage/src';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  border-radius: 4px;\n  background: ", ";\n\n  width: 100%;\n  padding: 8px 16px 8px 8px;\n\n  transition: transform 0.5s;\n  &:hover {\n    transform: scale(1.01);\n    cursor: pointer;\n  }\n"])), styleVariables.colors.gray3);
var ImagePreview = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 24px;\n\n  border: 1px solid lightgray;\n"])));
var FileSize = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n"])));
export var SubmissionFilePreview = function SubmissionFilePreview(props) {
  var signedUrl = props.signedUrl,
      type = props.type,
      onClick = props.onClick;

  var _useTranslation = useTranslation('common'),
      translationCommon = _useTranslation.t;

  var renderPreviewFileByType = function renderPreviewFileByType() {
    switch (type) {
      case FileType.Image:
        {
          return /*#__PURE__*/_jsx(ImagePreview, {
            src: signedUrl
          });
        }
    }
  };

  return /*#__PURE__*/_jsxs(Content, {
    onClick: onClick,
    children: [renderPreviewFileByType(), /*#__PURE__*/_jsx(Space, {
      direction: "horizontal",
      size: "middle",
      children: /*#__PURE__*/_jsx(FileSize, {
        children: translationCommon('viewDetail')
      })
    })]
  });
};